<template>
  <div>
    <b-row class="mt-2" v-if='subject'>
      <b-col cols="1" style='min-width: 72px'>
      </b-col>
      <b-col>
        <h5 class="mb-3">{{subject}} <img class="ml-2" style="opacity:0.54" src="https://www.gstatic.com/images/icons/material/system/1x/label_important_googyellow500_20dp.png" /><b-badge class="ml-2 google-blue">Inbox</b-badge></h5>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="1" class="text-right" style='min-width: 72px'>
        <b-avatar class='google-blue'></b-avatar>
      </b-col>
      <b-col>
        <div><span class="font-weight-bold">{{from_name}}</span> &lt;{{from_email}}&gt;</div>
        <div class="mb-4">to <span v-if='to_email'>{{to_email}}</span><span v-else>name@example.com</span></div>
        <div class="message-preview" v-html="templated_body"></div>
      </b-col>
    </b-row>
  </div>
</template>



<script>
import Handlebars from "handlebars"

export default {
  name: 'Email',
  props: ['subject', 'from_name', 'from_email', 'to_email', 'body', 'variables'],
  computed: {
    templated_body() {
      return Handlebars.compile(this.body)(this.variables)
    }
  },
}
</script>

<style>

.message-preview {
  white-space: pre;
  color: #222 !important;
  max-width: 100%;
  white-space: normal;
}

.message-preview p {
  color: #222 !important;

}

</style>
